import React from 'react'
import { PageContainer } from 'src/component/page-container/page-container'
import { SectionTitle } from 'src/component/ui/section-title'
import { cn } from 'src/lib/utils'

interface ProfileSectionProps {
  children: React.ReactNode
  theme?: 'light' | 'dark'
  className?: string
}

export const ProfileSection = ({ children, theme = 'dark', className }: ProfileSectionProps): React.ReactElement => {
  const bgColor = theme === 'light' ? 'bg-white' : 'bg-black'

  return (
    <div className={cn('py-6 md:py-[82px]', bgColor, className)}>
      <PageContainer>{children}</PageContainer>
    </div>
  )
}

interface ProfileSectionHeaderProps {
  children: React.ReactNode
  className?: string
}

ProfileSection.Header = ({ children, className }: ProfileSectionHeaderProps): React.ReactElement => {
  return <div className={cn('flex items-center justify-between mb-10', className)}>{children}</div>
}

interface ProfileSectionTitleProps {
  children: React.ReactNode
}

ProfileSection.Title = ({ children }: ProfileSectionTitleProps): React.ReactElement => {
  return <SectionTitle>{children}</SectionTitle>
}

interface ProfileSectionContentProps {
  isLoading: boolean
  isEmpty: boolean
  skeleton: React.ReactNode
  empty: React.ReactNode
  children: React.ReactNode
}

ProfileSection.Content = ({ isLoading, isEmpty, skeleton, empty, children }: ProfileSectionContentProps): React.ReactElement => {
  if (isLoading) return <>{skeleton}</>
  if (isEmpty) return <>{empty}</>
  return <>{children}</>
}
